/**
 * @generated SignedSource<<600c09983a32d5046c10fd87d53ed6d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OnboardingWorkspacePageCreateMutation$variables = {
  name: string;
};
export type OnboardingWorkspacePageCreateMutation$data = {
  readonly createWorkspace: {
    readonly id: string;
    readonly name: string;
  };
};
export type OnboardingWorkspacePageCreateMutation = {
  response: OnboardingWorkspacePageCreateMutation$data;
  variables: OnboardingWorkspacePageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "Workspace",
    "kind": "LinkedField",
    "name": "createWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingWorkspacePageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingWorkspacePageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d542e1ba7d5622bb53fcb17534761371",
    "id": null,
    "metadata": {},
    "name": "OnboardingWorkspacePageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OnboardingWorkspacePageCreateMutation(\n  $name: String!\n) {\n  createWorkspace(name: $name) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "8493ed6ad0478b31e0fe0df2212fb807";

export default node;
